import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { createLabeledBoxTheme, StyledUnclickableLabeledBox, ROOT_PREFIX } from './labeledBoxStyles';
export var EmbersLabeledBox = function EmbersLabeledBox(_ref) {
  var className = _ref.className,
    _ref$labelClickable = _ref.labelClickable,
    labelClickable = _ref$labelClickable === void 0 ? false : _ref$labelClickable,
    label = _ref.label,
    formControlProps = _ref.formControlProps,
    children = _ref.children,
    disabled = _ref.disabled;
  var preventClick = function preventClick(event) {
    event.preventDefault();
  };
  var formControlLabelClassName = classnames(ROOT_PREFIX, className, _defineProperty({}, "".concat(ROOT_PREFIX, "-disabled"), disabled));
  var boxChildren = children;
  if (label) {
    if (labelClickable) {
      boxChildren = /*#__PURE__*/React.createElement(FormControlLabel, _extends({
        control: children,
        label: label,
        className: formControlLabelClassName
      }, formControlProps));
    } else {
      boxChildren = /*#__PURE__*/React.createElement(StyledUnclickableLabeledBox, {
        className: formControlLabelClassName
      }, children, /*#__PURE__*/React.createElement(Typography, {
        onClick: preventClick
      }, label));
    }
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createLabeledBoxTheme
  }, boxChildren);
};